<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Move Inventory</h2>
      <div class="modal-subtitle">{{this.subtitle}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faLocationDot" class="section-icon"></fa-icon>
        <h3>Destination</h3>
        <div class="section-actions">
          <button mat-stroked-button type="button" (click)="scan()">
            <fa-icon [icon]="faBarcode" class="me-2"></fa-icon>Scan Location
          </button>
        </div>
      </div>

      <div class="current-location" *ngIf="this.currentLocation">
        <fa-icon [icon]="faWarehouse"></fa-icon>Currently <b>{{this.currentLocation}}</b>
      </div>

      <div class="section-grid cols-3">
        <mat-form-field appearance="outline">
          <mat-label>{{"Warehouse" | tenantWords}}</mat-label>
          <mat-select id="warehouse" [(ngModel)]="this.moveToHum.warehouseId" name="warehouse"
            (selectionChange)="this.warehouseSelectionChanged()">
            <mat-option *ngFor="let warehouse of this.warehouses" [value]="warehouse.id">
              {{warehouse.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{"Room" | tenantWords}}</mat-label>
          <mat-select id="room" [(ngModel)]="this.moveToHum.roomId" name="room"
            (selectionChange)="this.roomSelectionChanged()">
            <mat-option *ngFor="let room of this.rooms" [value]="room.id">
              {{room.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{"Location" | tenantWords}}</mat-label>
          <mat-select id="location" [(ngModel)]="this.moveToHum.roomLocationId" name="location"
            (selectionChange)="this.locationSelectionChanged()">
            <mat-option *ngFor="let location of this.locations" [value]="location.id">
              {{location.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faFileLines" class="section-icon"></fa-icon>
        <h3>{{"Reason" | tenantWords}}</h3>
      </div>
      <mat-form-field appearance="outline" class="reason-field">
        <mat-label>{{"Reason" | tenantWords}}</mat-label>
        <mat-select id="reason" [(ngModel)]="this.moveToHum.transactionReasonCodeId" name="reason" required>
          <mat-option *ngFor="let re of this.transactionReasons" [value]="re.id">
            {{re.reason}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="contamination-note" role="note" *ngIf="this.showContaminationChecks">
        <h4>Contamination Checks</h4>
        <p>
          SCAN AND DELETE ALL SEVERELY CONTAMINATED VESSELS, which include any fuzzy or sporulating type fungal
          infestations, and bacterial infestations that are growing quickly. The vessels themselves should be THROWN
          AWAY.
        </p>
        <p>
          All vessels with minor contamination including hazy bases, transparent films or very small colonies, and
          having no major effect on plant growth must be moved into the fridge grouped by GT.
        </p>
        <p>
          Thrips infested vessels should be moved into the fridge, grouped by GT. Vessels found to be contaminated when
          inspecting just prior to micropropagating should be placed in the fridge, Grouped by GT.
        </p>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button class="danger-btn" type="button"
      (click)="this.data.hum.isMultiple ? removeInventoryBulk() : removeInventory()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Remove
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="button"
      (click)="this.data.hum.isMultiple ? saveBulkMove() : submit()">
      <fa-icon [icon]="faArrowRight" class="me-2"></fa-icon>Move
    </button>
  </div>

</div>
